var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "d-flex flex-column align-center mb-12 rounded-lg"
  }, [_c('h1', {
    staticClass: "text-h2 text-center primary--text font-weight-bold"
  }, [_vm._v("Select Books")]), _c('v-card', {
    staticClass: "mt-16",
    attrs: {
      "max-width": "1200px",
      "width": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "primary--text"
  }, [_c('img', {
    staticClass: "d-block my-4 rounded mx-auto",
    attrs: {
      "height": "200px",
      "width": "300px",
      "src": "https://media.eipl.org/site/images/services/select-books.jpg"
    }
  }), _c('p', {
    staticClass: "text-h5 primary--text font-weight-bold my-12"
  }, [_vm._v("Let us help you put together a list of good reads!")]), _c('p', {
    staticClass: "text-body-1 primary--text text--lighten-2 font-weight-bold mb-0"
  }, [_vm._v("Read everything your favorite author has written and want to read more?")]), _c('p', {
    staticClass: "text-body-1 primary--text text--lighten-2 font-weight-bold"
  }, [_vm._v("Want a read-a-like of your favorite title?")]), _c('p', {
    staticClass: "text-body-1 primary-text"
  }, [_vm._v(" Just complete as many questions as you like on the form below and the staff will create a custom book list for you within 72 hours. The more you tell us about your reading habits, the better we can match you with a list of new reading suggestions. ")])])], 1), _c('v-sheet', {
    staticClass: "rounded my-8",
    attrs: {
      "color": "transparent",
      "max-width": "1200px",
      "width": "100%"
    }
  }, [_vm.isSuccess ? [_c('v-card', {
    ref: "submissionSummary"
  }, [_c('v-card-title', [_c('h2', {
    staticClass: "success--text"
  }, [_vm._v("Thank You for Your Submission!")])]), _c('v-card-text', [_c('p', {
    staticClass: "text-body-1 mb-2"
  }, [_vm._v("You will receive a confirmation E-mail shortly.")]), _c('p', {
    staticClass: "text-body-1 mb-2"
  }, [_vm._v("Please allow for up to 72 hours for a follow up E-mail with your curated reading lists.")])])], 1), _c('select-books-summary', {
    staticClass: "mt-4",
    attrs: {
      "formData": _vm.formData
    }
  })] : _c('select-books-form', {
    on: {
      "success": _vm.onSuccess
    }
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }